/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.mu.routing.proto.City', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ClientPoint', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ClientPointRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Company', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Country', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateDistributionMassiveRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateDistributionMassiveResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateMassiveDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateMassiveDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DeliveryFilter', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DeliveryNewFilter', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DeliveryPackageSize', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DeliveryPackageStaus', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DeliveryStatusType', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DistributionRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.DistributionResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ErrorCode', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetFileSignedUrlRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetFileSignedUrlResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetMassiveDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetMassiveDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetRoutingRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.GetRoutingResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListCitiesNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListCitiesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListCitiesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListCountriesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListCountriesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListDistributionCenterRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListDistributionCenterResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListLocalitiesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListLocalitiesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListRoutingServicesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListRoutingServicesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListRoutingVehiclesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListRoutingVehiclesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListZonesRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListZonesResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListenRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ListenResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Localities', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.LocalitiesList', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryServiceDetail', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.PackageSizes', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.PaginationRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.PaginationResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ProgramDeliveryRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.ProgramDeliveryResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.RouteNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.RouteRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.RouteResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.RoutedService', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Sizes', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.StatusInfo', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.StatusType', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateVehicleOrderRequest', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.UpdateVehicleOrderResponse', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Vehicle', null, global);
goog.exportSymbol('proto.com.mu.routing.proto.Zone', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Company = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.Company, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Company.displayName = 'proto.com.mu.routing.proto.Company';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListCitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListCitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListCitiesRequest.displayName = 'proto.com.mu.routing.proto.ListCitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListCitiesNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListCitiesNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListCitiesNewRequest.displayName = 'proto.com.mu.routing.proto.ListCitiesNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListCitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListCitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListCitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListCitiesResponse.displayName = 'proto.com.mu.routing.proto.ListCitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.City = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.City, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.City.displayName = 'proto.com.mu.routing.proto.City';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.DistributionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.DistributionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.DistributionRequest.displayName = 'proto.com.mu.routing.proto.DistributionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.DistributionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.DistributionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.DistributionResponse.displayName = 'proto.com.mu.routing.proto.DistributionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListDistributionCenterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListDistributionCenterRequest.displayName = 'proto.com.mu.routing.proto.ListDistributionCenterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListDistributionCenterResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListDistributionCenterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListDistributionCenterResponse.displayName = 'proto.com.mu.routing.proto.ListDistributionCenterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateDistributionMassiveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateDistributionMassiveRequest.displayName = 'proto.com.mu.routing.proto.CreateDistributionMassiveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.CreateDistributionMassiveResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateDistributionMassiveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateDistributionMassiveResponse.displayName = 'proto.com.mu.routing.proto.CreateDistributionMassiveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.displayName = 'proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ClientPointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ClientPointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ClientPointRequest.displayName = 'proto.com.mu.routing.proto.ClientPointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ClientPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ClientPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ClientPoint.displayName = 'proto.com.mu.routing.proto.ClientPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListZonesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListZonesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListZonesRequest.displayName = 'proto.com.mu.routing.proto.ListZonesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListZonesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListZonesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListZonesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListZonesResponse.displayName = 'proto.com.mu.routing.proto.ListZonesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Zone = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.Zone, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Zone.displayName = 'proto.com.mu.routing.proto.Zone';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ProgramDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ProgramDeliveryRequest.displayName = 'proto.com.mu.routing.proto.ProgramDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ProgramDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ProgramDeliveryResponse.displayName = 'proto.com.mu.routing.proto.ProgramDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListRoutingServicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListRoutingServicesRequest.displayName = 'proto.com.mu.routing.proto.ListRoutingServicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListRoutingServicesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListRoutingServicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListRoutingServicesResponse.displayName = 'proto.com.mu.routing.proto.ListRoutingServicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListRoutingVehiclesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListRoutingVehiclesRequest.displayName = 'proto.com.mu.routing.proto.ListRoutingVehiclesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListRoutingVehiclesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListRoutingVehiclesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListRoutingVehiclesResponse.displayName = 'proto.com.mu.routing.proto.ListRoutingVehiclesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Vehicle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.Vehicle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Vehicle.displayName = 'proto.com.mu.routing.proto.Vehicle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetRoutingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.GetRoutingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetRoutingRequest.displayName = 'proto.com.mu.routing.proto.GetRoutingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.RoutedService = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.RoutedService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.RoutedService.displayName = 'proto.com.mu.routing.proto.RoutedService';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetRoutingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.GetRoutingResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.GetRoutingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetRoutingResponse.displayName = 'proto.com.mu.routing.proto.GetRoutingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListenRequest.displayName = 'proto.com.mu.routing.proto.ListenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListenResponse.displayName = 'proto.com.mu.routing.proto.ListenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.displayName = 'proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.displayName = 'proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.displayName = 'proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.displayName = 'proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.displayName = 'proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateMassiveDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.displayName = 'proto.com.mu.routing.proto.CreateMassiveDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateMassiveDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.displayName = 'proto.com.mu.routing.proto.CreateMassiveDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.displayName = 'proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.DeliveryFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.DeliveryFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.DeliveryFilter.displayName = 'proto.com.mu.routing.proto.DeliveryFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Localities = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.Localities.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.Localities, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Localities.displayName = 'proto.com.mu.routing.proto.Localities';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Sizes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.Sizes.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.Sizes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Sizes.displayName = 'proto.com.mu.routing.proto.Sizes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.DeliveryNewFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.DeliveryNewFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.DeliveryNewFilter.displayName = 'proto.com.mu.routing.proto.DeliveryNewFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListMassiveDeliveryResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryResponse.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryRequest.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryNewRequest.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.GetMassiveDeliveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetMassiveDeliveryRequest.displayName = 'proto.com.mu.routing.proto.GetMassiveDeliveryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.GetMassiveDeliveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetMassiveDeliveryResponse.displayName = 'proto.com.mu.routing.proto.GetMassiveDeliveryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.displayName = 'proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.RouteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.RouteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.RouteRequest.displayName = 'proto.com.mu.routing.proto.RouteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.RouteNewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.RouteNewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.RouteNewRequest.displayName = 'proto.com.mu.routing.proto.RouteNewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.RouteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.RouteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.RouteResponse.displayName = 'proto.com.mu.routing.proto.RouteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.displayName = 'proto.com.mu.routing.proto.MassiveDeliveryServiceDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.UpdateVehicleOrderRequest.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateVehicleOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateVehicleOrderRequest.displayName = 'proto.com.mu.routing.proto.UpdateVehicleOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.UpdateVehicleOrderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.UpdateVehicleOrderResponse.displayName = 'proto.com.mu.routing.proto.UpdateVehicleOrderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.GetFileSignedUrlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetFileSignedUrlRequest.displayName = 'proto.com.mu.routing.proto.GetFileSignedUrlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.GetFileSignedUrlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.GetFileSignedUrlResponse.displayName = 'proto.com.mu.routing.proto.GetFileSignedUrlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.StatusInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.StatusInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.StatusInfo.displayName = 'proto.com.mu.routing.proto.StatusInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.PaginationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.PaginationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.PaginationRequest.displayName = 'proto.com.mu.routing.proto.PaginationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.PaginationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.PaginationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.PaginationResponse.displayName = 'proto.com.mu.routing.proto.PaginationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListCountriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListCountriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListCountriesRequest.displayName = 'proto.com.mu.routing.proto.ListCountriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListCountriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListCountriesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListCountriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListCountriesResponse.displayName = 'proto.com.mu.routing.proto.ListCountriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.Country = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.Country, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.Country.displayName = 'proto.com.mu.routing.proto.Country';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.displayName = 'proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.PackageSizes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.PackageSizes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.PackageSizes.displayName = 'proto.com.mu.routing.proto.PackageSizes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.displayName = 'proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListLocalitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.ListLocalitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListLocalitiesRequest.displayName = 'proto.com.mu.routing.proto.ListLocalitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.LocalitiesList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.mu.routing.proto.LocalitiesList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.LocalitiesList.displayName = 'proto.com.mu.routing.proto.LocalitiesList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.mu.routing.proto.ListLocalitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.mu.routing.proto.ListLocalitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.mu.routing.proto.ListLocalitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.mu.routing.proto.ListLocalitiesResponse.displayName = 'proto.com.mu.routing.proto.ListLocalitiesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    country: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string country = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesNewRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    companiesList: jspb.Message.toObjectList(msg.getCompaniesList(),
    proto.com.mu.routing.proto.Company.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse;
  return proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.Company;
      reader.readMessage(value,proto.com.mu.routing.proto.Company.deserializeBinaryFromReader);
      msg.addCompanies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompaniesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.Company.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Company companies = 1;
 * @return {!Array<!proto.com.mu.routing.proto.Company>}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.getCompaniesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.Company>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.Company, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.Company>} value */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.setCompaniesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.Company=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.Company}
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.addCompanies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.Company, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListMassiveDeliverCompaniesResponse.prototype.clearCompaniesList = function() {
  this.setCompaniesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Company.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Company.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Company} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Company.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Company}
 */
proto.com.mu.routing.proto.Company.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Company;
  return proto.com.mu.routing.proto.Company.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Company} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Company}
 */
proto.com.mu.routing.proto.Company.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Company.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Company.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Company} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Company.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.Company.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Company.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.Company.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Company.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListCitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListCitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListCitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    namequery: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListCitiesRequest}
 */
proto.com.mu.routing.proto.ListCitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListCitiesRequest;
  return proto.com.mu.routing.proto.ListCitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListCitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListCitiesRequest}
 */
proto.com.mu.routing.proto.ListCitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamequery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListCitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListCitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListCitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamequery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string nameQuery = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListCitiesRequest.prototype.getNamequery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListCitiesRequest.prototype.setNamequery = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListCitiesNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListCitiesNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    namequery: jspb.Message.getFieldWithDefault(msg, 1, ""),
    country: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListCitiesNewRequest}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListCitiesNewRequest;
  return proto.com.mu.routing.proto.ListCitiesNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListCitiesNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListCitiesNewRequest}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamequery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListCitiesNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListCitiesNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamequery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string nameQuery = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.getNamequery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.setNamequery = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string country = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListCitiesNewRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListCitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListCitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListCitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    citiesList: jspb.Message.toObjectList(msg.getCitiesList(),
    proto.com.mu.routing.proto.City.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListCitiesResponse}
 */
proto.com.mu.routing.proto.ListCitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListCitiesResponse;
  return proto.com.mu.routing.proto.ListCitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListCitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListCitiesResponse}
 */
proto.com.mu.routing.proto.ListCitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.City;
      reader.readMessage(value,proto.com.mu.routing.proto.City.deserializeBinaryFromReader);
      msg.addCities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListCitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListCitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.City.serializeBinaryToWriter
    );
  }
};


/**
 * repeated City cities = 1;
 * @return {!Array<!proto.com.mu.routing.proto.City>}
 */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.getCitiesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.City>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.City, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.City>} value */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.setCitiesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.City=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.City}
 */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.addCities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.City, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListCitiesResponse.prototype.clearCitiesList = function() {
  this.setCitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.City.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.City.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.City} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.City.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    geoname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.City}
 */
proto.com.mu.routing.proto.City.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.City;
  return proto.com.mu.routing.proto.City.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.City} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.City}
 */
proto.com.mu.routing.proto.City.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeoname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.City.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.City.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.City} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.City.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGeoname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.City.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.City.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.City.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.City.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string geoName = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.City.prototype.getGeoname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.City.prototype.setGeoname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.DistributionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.DistributionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.DistributionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DistributionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.DistributionRequest}
 */
proto.com.mu.routing.proto.DistributionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.DistributionRequest;
  return proto.com.mu.routing.proto.DistributionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.DistributionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.DistributionRequest}
 */
proto.com.mu.routing.proto.DistributionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.DistributionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.DistributionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.DistributionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DistributionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.DistributionRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.DistributionRequest.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.DistributionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.DistributionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.DistributionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DistributionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    response: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.DistributionResponse}
 */
proto.com.mu.routing.proto.DistributionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.DistributionResponse;
  return proto.com.mu.routing.proto.DistributionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.DistributionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.DistributionResponse}
 */
proto.com.mu.routing.proto.DistributionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.DistributionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.DistributionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.DistributionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DistributionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResponse();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string response = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.DistributionResponse.prototype.getResponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.DistributionResponse.prototype.setResponse = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListDistributionCenterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cityid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    showstores: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListDistributionCenterRequest}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListDistributionCenterRequest;
  return proto.com.mu.routing.proto.ListDistributionCenterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListDistributionCenterRequest}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowstores(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListDistributionCenterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getShowstores();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cityId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool showStores = 3;
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.getShowstores = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.ListDistributionCenterRequest.prototype.setShowstores = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListDistributionCenterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientpointsList: jspb.Message.toObjectList(msg.getClientpointsList(),
    proto.com.mu.routing.proto.ClientPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListDistributionCenterResponse}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListDistributionCenterResponse;
  return proto.com.mu.routing.proto.ListDistributionCenterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListDistributionCenterResponse}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.ClientPoint;
      reader.readMessage(value,proto.com.mu.routing.proto.ClientPoint.deserializeBinaryFromReader);
      msg.addClientpoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListDistributionCenterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListDistributionCenterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientpointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.ClientPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClientPoint clientPoints = 1;
 * @return {!Array<!proto.com.mu.routing.proto.ClientPoint>}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.getClientpointsList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.ClientPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.ClientPoint, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.ClientPoint>} value */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.setClientpointsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.ClientPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.ClientPoint}
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.addClientpoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.ClientPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListDistributionCenterResponse.prototype.clearClientpointsList = function() {
  this.setClientpointsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateDistributionMassiveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    showstores: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    fileid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateDistributionMassiveRequest}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateDistributionMassiveRequest;
  return proto.com.mu.routing.proto.CreateDistributionMassiveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateDistributionMassiveRequest}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowstores(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateDistributionMassiveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getShowstores();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool showStores = 2;
 * @return {boolean}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.getShowstores = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.setShowstores = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string fileId = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.getFileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateDistributionMassiveRequest.prototype.setFileid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateDistributionMassiveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientsList: jspb.Message.toObjectList(msg.getClientsList(),
    proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateDistributionMassiveResponse}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateDistributionMassiveResponse;
  return proto.com.mu.routing.proto.CreateDistributionMassiveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateDistributionMassiveResponse}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse;
      reader.readMessage(value,proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.deserializeBinaryFromReader);
      msg.addClients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateDistributionMassiveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateDistributionMassiveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CreateStatusDistributionCenterResponse clients = 1;
 * @return {!Array<!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse>}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.getClientsList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse>} value */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.setClientsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse}
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.addClients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.CreateDistributionMassiveResponse.prototype.clearClientsList = function() {
  this.setClientsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 5, ""),
    id: jspb.Message.getFieldWithDefault(msg, 6, 0),
    clientpoint: (f = msg.getClientpoint()) && proto.com.mu.routing.proto.ClientPoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse;
  return proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 7:
      var value = new proto.com.mu.routing.proto.ClientPoint;
      reader.readMessage(value,proto.com.mu.routing.proto.ClientPoint.deserializeBinaryFromReader);
      msg.setClientpoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getClientpoint();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.mu.routing.proto.ClientPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string address = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string lat = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string lng = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 id = 6;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ClientPoint clientPoint = 7;
 * @return {?proto.com.mu.routing.proto.ClientPoint}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.getClientpoint = function() {
  return /** @type{?proto.com.mu.routing.proto.ClientPoint} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.ClientPoint, 7));
};


/** @param {?proto.com.mu.routing.proto.ClientPoint|undefined} value */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.setClientpoint = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.clearClientpoint = function() {
  this.setClientpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.CreateStatusDistributionCenterResponse.prototype.hasClientpoint = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ClientPointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ClientPointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ClientPointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ClientPointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientpoint: (f = msg.getClientpoint()) && proto.com.mu.routing.proto.ClientPoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ClientPointRequest}
 */
proto.com.mu.routing.proto.ClientPointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ClientPointRequest;
  return proto.com.mu.routing.proto.ClientPointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ClientPointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ClientPointRequest}
 */
proto.com.mu.routing.proto.ClientPointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.ClientPoint;
      reader.readMessage(value,proto.com.mu.routing.proto.ClientPoint.deserializeBinaryFromReader);
      msg.setClientpoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ClientPointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ClientPointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ClientPointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ClientPointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientpoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.ClientPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClientPoint clientPoint = 1;
 * @return {?proto.com.mu.routing.proto.ClientPoint}
 */
proto.com.mu.routing.proto.ClientPointRequest.prototype.getClientpoint = function() {
  return /** @type{?proto.com.mu.routing.proto.ClientPoint} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.ClientPoint, 1));
};


/** @param {?proto.com.mu.routing.proto.ClientPoint|undefined} value */
proto.com.mu.routing.proto.ClientPointRequest.prototype.setClientpoint = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ClientPointRequest.prototype.clearClientpoint = function() {
  this.setClientpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ClientPointRequest.prototype.hasClientpoint = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ClientPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ClientPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ClientPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    companyid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    address: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 5, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    idcity: jspb.Message.getFieldWithDefault(msg, 8, 0),
    namecity: jspb.Message.getFieldWithDefault(msg, 9, ""),
    isdistributioncenter: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ClientPoint}
 */
proto.com.mu.routing.proto.ClientPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ClientPoint;
  return proto.com.mu.routing.proto.ClientPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ClientPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ClientPoint}
 */
proto.com.mu.routing.proto.ClientPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIdcity(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamecity(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdistributioncenter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ClientPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ClientPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ClientPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIdcity();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getNamecity();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIsdistributioncenter();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 companyId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string address = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string lat = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string lng = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 idCity = 8;
 * @return {number}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getIdcity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setIdcity = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string nameCity = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getNamecity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setNamecity = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool isDistributionCenter = 10;
 * @return {boolean}
 */
proto.com.mu.routing.proto.ClientPoint.prototype.getIsdistributioncenter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.ClientPoint.prototype.setIsdistributioncenter = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListZonesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListZonesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListZonesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListZonesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListZonesRequest}
 */
proto.com.mu.routing.proto.ListZonesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListZonesRequest;
  return proto.com.mu.routing.proto.ListZonesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListZonesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListZonesRequest}
 */
proto.com.mu.routing.proto.ListZonesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListZonesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListZonesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListZonesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListZonesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListZonesRequest.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListZonesRequest.prototype.setUserid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListZonesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListZonesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListZonesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListZonesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListZonesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    zonesList: jspb.Message.toObjectList(msg.getZonesList(),
    proto.com.mu.routing.proto.Zone.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListZonesResponse}
 */
proto.com.mu.routing.proto.ListZonesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListZonesResponse;
  return proto.com.mu.routing.proto.ListZonesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListZonesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListZonesResponse}
 */
proto.com.mu.routing.proto.ListZonesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.Zone;
      reader.readMessage(value,proto.com.mu.routing.proto.Zone.deserializeBinaryFromReader);
      msg.addZones(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListZonesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListZonesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListZonesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListZonesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZonesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.Zone.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Zone zones = 1;
 * @return {!Array<!proto.com.mu.routing.proto.Zone>}
 */
proto.com.mu.routing.proto.ListZonesResponse.prototype.getZonesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.Zone>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.Zone, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.Zone>} value */
proto.com.mu.routing.proto.ListZonesResponse.prototype.setZonesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.Zone=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.Zone}
 */
proto.com.mu.routing.proto.ListZonesResponse.prototype.addZones = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.Zone, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListZonesResponse.prototype.clearZonesList = function() {
  this.setZonesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Zone.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Zone.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Zone} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Zone.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Zone}
 */
proto.com.mu.routing.proto.Zone.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Zone;
  return proto.com.mu.routing.proto.Zone.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Zone} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Zone}
 */
proto.com.mu.routing.proto.Zone.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Zone.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Zone.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Zone} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Zone.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.Zone.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Zone.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ProgramDeliveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    vehicleid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    zone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subzone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    description: jspb.Message.getFieldWithDefault(msg, 6, ""),
    vehicletypeid: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ProgramDeliveryRequest}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ProgramDeliveryRequest;
  return proto.com.mu.routing.proto.ProgramDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ProgramDeliveryRequest}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setZone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubzone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicletypeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ProgramDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVehicleid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getZone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubzone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getVehicletypeid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 vehicleId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getVehicleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setVehicleid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 userId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setUserid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string zone = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setZone = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subZone = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getSubzone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setSubzone = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 vehicleTypeId = 7;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.getVehicletypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryRequest.prototype.setVehicletypeid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ProgramDeliveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    recordsquantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    recordsprocessed: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ProgramDeliveryResponse}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ProgramDeliveryResponse;
  return proto.com.mu.routing.proto.ProgramDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ProgramDeliveryResponse}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsquantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsprocessed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ProgramDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ProgramDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecordsquantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRecordsprocessed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 recordsQuantity = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.getRecordsquantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.setRecordsquantity = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 recordsProcessed = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.getRecordsprocessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ProgramDeliveryResponse.prototype.setRecordsprocessed = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListRoutingServicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListRoutingServicesRequest}
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListRoutingServicesRequest;
  return proto.com.mu.routing.proto.ListRoutingServicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListRoutingServicesRequest}
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListRoutingServicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 vehicleId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListRoutingServicesRequest.prototype.getVehicleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListRoutingServicesRequest.prototype.setVehicleid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListRoutingServicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListRoutingServicesResponse}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListRoutingServicesResponse;
  return proto.com.mu.routing.proto.ListRoutingServicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListRoutingServicesResponse}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListRoutingServicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListRoutingServicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MassiveDeliveryServiceDetail details = 1;
 * @return {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>} value */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.setDetailsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListRoutingServicesResponse.prototype.clearDetailsList = function() {
  this.setDetailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListRoutingVehiclesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListRoutingVehiclesRequest}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListRoutingVehiclesRequest;
  return proto.com.mu.routing.proto.ListRoutingVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListRoutingVehiclesRequest}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListRoutingVehiclesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListRoutingVehiclesRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListRoutingVehiclesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehiclesList: jspb.Message.toObjectList(msg.getVehiclesList(),
    proto.com.mu.routing.proto.Vehicle.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListRoutingVehiclesResponse}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListRoutingVehiclesResponse;
  return proto.com.mu.routing.proto.ListRoutingVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListRoutingVehiclesResponse}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.Vehicle;
      reader.readMessage(value,proto.com.mu.routing.proto.Vehicle.deserializeBinaryFromReader);
      msg.addVehicles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListRoutingVehiclesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListRoutingVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehiclesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.Vehicle.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Vehicle vehicles = 1;
 * @return {!Array<!proto.com.mu.routing.proto.Vehicle>}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.getVehiclesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.Vehicle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.Vehicle, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.Vehicle>} value */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.setVehiclesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.Vehicle}
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.addVehicles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.Vehicle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListRoutingVehiclesResponse.prototype.clearVehiclesList = function() {
  this.setVehiclesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Vehicle.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Vehicle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Vehicle.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    routingid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    plate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    capacity: jspb.Message.getFieldWithDefault(msg, 5, 0),
    usedcapacity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    type: jspb.Message.getFieldWithDefault(msg, 7, ""),
    apiserviceid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    apiservicemessage: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Vehicle}
 */
proto.com.mu.routing.proto.Vehicle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Vehicle;
  return proto.com.mu.routing.proto.Vehicle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Vehicle}
 */
proto.com.mu.routing.proto.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoutingid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCapacity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsedcapacity(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiserviceid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiservicemessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Vehicle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Vehicle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Vehicle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRoutingid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPlate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCapacity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getUsedcapacity();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getApiserviceid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getApiservicemessage();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int32 vehicleId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getVehicleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Vehicle.prototype.setVehicleid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 routingId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getRoutingid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Vehicle.prototype.setRoutingid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string plate = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getPlate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Vehicle.prototype.setPlate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 capacity = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getCapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Vehicle.prototype.setCapacity = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 usedCapacity = 6;
 * @return {number}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getUsedcapacity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Vehicle.prototype.setUsedcapacity = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Vehicle.prototype.setType = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string apiServiceId = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getApiserviceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Vehicle.prototype.setApiserviceid = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string apiServiceMessage = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.Vehicle.prototype.getApiservicemessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Vehicle.prototype.setApiservicemessage = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetRoutingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetRoutingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetRoutingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetRoutingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetRoutingRequest}
 */
proto.com.mu.routing.proto.GetRoutingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetRoutingRequest;
  return proto.com.mu.routing.proto.GetRoutingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetRoutingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetRoutingRequest}
 */
proto.com.mu.routing.proto.GetRoutingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetRoutingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetRoutingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetRoutingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetRoutingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.GetRoutingRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.GetRoutingRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.RoutedService.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.RoutedService.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.RoutedService} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RoutedService.toObject = function(includeInstance, msg) {
  var f, obj = {
    service: (f = msg.getService()) && proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject(includeInstance, f),
    order: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.RoutedService}
 */
proto.com.mu.routing.proto.RoutedService.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.RoutedService;
  return proto.com.mu.routing.proto.RoutedService.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.RoutedService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.RoutedService}
 */
proto.com.mu.routing.proto.RoutedService.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader);
      msg.setService(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.RoutedService.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.RoutedService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.RoutedService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RoutedService.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getService();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional MassiveDeliveryServiceDetail service = 1;
 * @return {?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.RoutedService.prototype.getService = function() {
  return /** @type{?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, 1));
};


/** @param {?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail|undefined} value */
proto.com.mu.routing.proto.RoutedService.prototype.setService = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.RoutedService.prototype.clearService = function() {
  this.setService(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.RoutedService.prototype.hasService = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 order = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.RoutedService.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RoutedService.prototype.setOrder = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.GetRoutingResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetRoutingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetRoutingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetRoutingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    routedserviceList: jspb.Message.toObjectList(msg.getRoutedserviceList(),
    proto.com.mu.routing.proto.RoutedService.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetRoutingResponse}
 */
proto.com.mu.routing.proto.GetRoutingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetRoutingResponse;
  return proto.com.mu.routing.proto.GetRoutingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetRoutingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetRoutingResponse}
 */
proto.com.mu.routing.proto.GetRoutingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.RoutedService;
      reader.readMessage(value,proto.com.mu.routing.proto.RoutedService.deserializeBinaryFromReader);
      msg.addRoutedservice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetRoutingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetRoutingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetRoutingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutedserviceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.RoutedService.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RoutedService routedService = 1;
 * @return {!Array<!proto.com.mu.routing.proto.RoutedService>}
 */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.getRoutedserviceList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.RoutedService>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.RoutedService, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.RoutedService>} value */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.setRoutedserviceList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.RoutedService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.RoutedService}
 */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.addRoutedservice = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.RoutedService, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.GetRoutingResponse.prototype.clearRoutedserviceList = function() {
  this.setRoutedserviceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListenRequest}
 */
proto.com.mu.routing.proto.ListenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListenRequest;
  return proto.com.mu.routing.proto.ListenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListenRequest}
 */
proto.com.mu.routing.proto.ListenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListenResponse}
 */
proto.com.mu.routing.proto.ListenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListenResponse;
  return proto.com.mu.routing.proto.ListenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListenResponse}
 */
proto.com.mu.routing.proto.ListenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListenResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListenResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    detail: (f = msg.getDetail()) && proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest;
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional MassiveDeliveryServiceDetail detail = 1;
 * @return {?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.getDetail = function() {
  return /** @type{?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, 1));
};


/** @param {?proto.com.mu.routing.proto.MassiveDeliveryServiceDetail|undefined} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.setDetail = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.clearDetail = function() {
  this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceRequest.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    detail: (f = msg.getDetail()) && proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest;
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional MassiveDeliveryServiceNewDetail detail = 1;
 * @return {?proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.getDetail = function() {
  return /** @type{?proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail, 1));
};


/** @param {?proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail|undefined} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.setDetail = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.clearDetail = function() {
  this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewRequest.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 3, ""),
    addresswrong: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse;
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddresswrong(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddresswrong();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string lat = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string lng = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 addressWrong = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.getAddresswrong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceResponse.prototype.setAddresswrong = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    mddeliverypkgid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    clientid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    address: jspb.Message.getFieldWithDefault(msg, 5, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 7, ""),
    countrygeoname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    citygeoname: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail;
  return proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMddeliverypkgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrygeoname(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitygeoname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMddeliverypkgid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCountrygeoname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCitygeoname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional int32 mdDeliveryPkgId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getMddeliverypkgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setMddeliverypkgid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string clientId = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setClientid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string orderId = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string clientName = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setClientname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string address = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string lat = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string lng = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string countryGeoName = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getCountrygeoname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setCountrygeoname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string cityGeoName = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.getCitygeoname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceNewDetail.prototype.setCitygeoname = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    mddeliverypkgid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    clientname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    address: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 7, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 8, ""),
    locality: jspb.Message.getFieldWithDefault(msg, 9, ""),
    iswrongaddress: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse;
  return proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMddeliverypkgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocality(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIswrongaddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMddeliverypkgid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLocality();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIswrongaddress();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional int32 mdDeliveryPkgId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getMddeliverypkgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setMddeliverypkgid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string clientId = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setClientid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string orderId = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string clientName = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setClientname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string address = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string lat = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string lng = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string locality = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getLocality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setLocality = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool isWrongAddress = 10;
 * @return {boolean}
 */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.getIswrongaddress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.UpdateMassiveDeliveryServiceNewResponse.prototype.setIswrongaddress = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cityid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cedipointid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fileid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cityname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest;
  return proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCedipointid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCedipointid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cityId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 cediPointId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getCedipointid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setCedipointid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string fileId = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getFileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setFileid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string cityName = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getCityname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setCityname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string country = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cityid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cedipointid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    startdate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    starttime: jspb.Message.getFieldWithDefault(msg, 5, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fileid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cityname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    vehicletypename: jspb.Message.getFieldWithDefault(msg, 9, ""),
    vehicletypeid: jspb.Message.getFieldWithDefault(msg, 10, 0),
    country: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateMassiveDeliveryRequest;
  return proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCedipointid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicletypename(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicletypeid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCedipointid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVehicletypename();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getVehicletypeid();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cityId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 cediPointId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getCedipointid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setCedipointid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string startDate = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setStartdate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string startTime = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getStarttime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setStarttime = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string endTime = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setEndtime = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fileId = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getFileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setFileid = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string cityName = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getCityname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setCityname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string vehicleTypeName = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getVehicletypename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setVehicletypename = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 vehicleTypeId = 10;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getVehicletypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setVehicletypeid = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string country = 11;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    recordsquantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    recordsprocessed: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateMassiveDeliveryResponse;
  return proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsquantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsprocessed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRecordsquantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRecordsprocessed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 requestId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 recordsQuantity = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.getRecordsquantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.setRecordsquantity = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 recordsProcessed = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.getRecordsprocessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryResponse.prototype.setRecordsprocessed = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    companyid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cedipointid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cityid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    recordsquantity: jspb.Message.getFieldWithDefault(msg, 6, 0),
    recordsprocessed: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse;
  return proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCedipointid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsquantity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsprocessed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCedipointid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRecordsquantity();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getRecordsprocessed();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 companyId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 cediPointId = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getCedipointid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setCedipointid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 cityId = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 recordsQuantity = 6;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getRecordsquantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setRecordsquantity = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 recordsProcessed = 7;
 * @return {number}
 */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.getRecordsprocessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.CreateMassiveDeliveryNewResponse.prototype.setRecordsprocessed = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.DeliveryFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.DeliveryFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.DeliveryFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DeliveryFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.DeliveryFilter}
 */
proto.com.mu.routing.proto.DeliveryFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.DeliveryFilter;
  return proto.com.mu.routing.proto.DeliveryFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.DeliveryFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.DeliveryFilter}
 */
proto.com.mu.routing.proto.DeliveryFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.mu.routing.proto.DeliveryStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.DeliveryFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.DeliveryFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.DeliveryFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DeliveryFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional DeliveryStatusType status = 1;
 * @return {!proto.com.mu.routing.proto.DeliveryStatusType}
 */
proto.com.mu.routing.proto.DeliveryFilter.prototype.getStatus = function() {
  return /** @type {!proto.com.mu.routing.proto.DeliveryStatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.com.mu.routing.proto.DeliveryStatusType} value */
proto.com.mu.routing.proto.DeliveryFilter.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.Localities.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Localities.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Localities.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Localities} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Localities.toObject = function(includeInstance, msg) {
  var f, obj = {
    localityList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Localities}
 */
proto.com.mu.routing.proto.Localities.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Localities;
  return proto.com.mu.routing.proto.Localities.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Localities} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Localities}
 */
proto.com.mu.routing.proto.Localities.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addLocality(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Localities.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Localities.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Localities} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Localities.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalityList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string locality = 1;
 * @return {!Array<string>}
 */
proto.com.mu.routing.proto.Localities.prototype.getLocalityList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.com.mu.routing.proto.Localities.prototype.setLocalityList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.com.mu.routing.proto.Localities.prototype.addLocality = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.Localities.prototype.clearLocalityList = function() {
  this.setLocalityList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.Sizes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Sizes.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Sizes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Sizes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Sizes.toObject = function(includeInstance, msg) {
  var f, obj = {
    sizeentryList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Sizes}
 */
proto.com.mu.routing.proto.Sizes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Sizes;
  return proto.com.mu.routing.proto.Sizes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Sizes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Sizes}
 */
proto.com.mu.routing.proto.Sizes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSizeentryList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Sizes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Sizes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Sizes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Sizes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSizeentryList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 sizeEntry = 1;
 * @return {!Array<number>}
 */
proto.com.mu.routing.proto.Sizes.prototype.getSizeentryList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.com.mu.routing.proto.Sizes.prototype.setSizeentryList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.com.mu.routing.proto.Sizes.prototype.addSizeentry = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.Sizes.prototype.clearSizeentryList = function() {
  this.setSizeentryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.DeliveryNewFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.DeliveryNewFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DeliveryNewFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    localities: (f = msg.getLocalities()) && proto.com.mu.routing.proto.Localities.toObject(includeInstance, f),
    sizes: (f = msg.getSizes()) && proto.com.mu.routing.proto.Sizes.toObject(includeInstance, f),
    startdate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    duedate: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.DeliveryNewFilter}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.DeliveryNewFilter;
  return proto.com.mu.routing.proto.DeliveryNewFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.DeliveryNewFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.DeliveryNewFilter}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.Localities;
      reader.readMessage(value,proto.com.mu.routing.proto.Localities.deserializeBinaryFromReader);
      msg.setLocalities(value);
      break;
    case 3:
      var value = new proto.com.mu.routing.proto.Sizes;
      reader.readMessage(value,proto.com.mu.routing.proto.Sizes.deserializeBinaryFromReader);
      msg.setSizes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDuedate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.DeliveryNewFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.DeliveryNewFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.DeliveryNewFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocalities();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.Localities.serializeBinaryToWriter
    );
  }
  f = message.getSizes();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.mu.routing.proto.Sizes.serializeBinaryToWriter
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDuedate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string orderId = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Localities localities = 2;
 * @return {?proto.com.mu.routing.proto.Localities}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.getLocalities = function() {
  return /** @type{?proto.com.mu.routing.proto.Localities} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.Localities, 2));
};


/** @param {?proto.com.mu.routing.proto.Localities|undefined} value */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.setLocalities = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.clearLocalities = function() {
  this.setLocalities(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.hasLocalities = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Sizes sizes = 3;
 * @return {?proto.com.mu.routing.proto.Sizes}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.getSizes = function() {
  return /** @type{?proto.com.mu.routing.proto.Sizes} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.Sizes, 3));
};


/** @param {?proto.com.mu.routing.proto.Sizes|undefined} value */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.setSizes = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.clearSizes = function() {
  this.setSizes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.hasSizes = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string startDate = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.setStartdate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string dueDate = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.getDuedate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.DeliveryNewFilter.prototype.setDuedate = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filters: (f = msg.getFilters()) && proto.com.mu.routing.proto.DeliveryFilter.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.DeliveryFilter;
      reader.readMessage(value,proto.com.mu.routing.proto.DeliveryFilter.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.PaginationRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.DeliveryFilter.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeliveryFilter filters = 1;
 * @return {?proto.com.mu.routing.proto.DeliveryFilter}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.getFilters = function() {
  return /** @type{?proto.com.mu.routing.proto.DeliveryFilter} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.DeliveryFilter, 1));
};


/** @param {?proto.com.mu.routing.proto.DeliveryFilter|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.setFilters = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.clearFilters = function() {
  this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PaginationRequest pagination = 2;
 * @return {?proto.com.mu.routing.proto.PaginationRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationRequest, 2));
};


/** @param {?proto.com.mu.routing.proto.PaginationRequest|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cedi: jspb.Message.getFieldWithDefault(msg, 2, 0),
    filters: (f = msg.getFilters()) && proto.com.mu.routing.proto.DeliveryNewFilter.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCedi(value);
      break;
    case 3:
      var value = new proto.com.mu.routing.proto.DeliveryNewFilter;
      reader.readMessage(value,proto.com.mu.routing.proto.DeliveryNewFilter.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 4:
      var value = new proto.com.mu.routing.proto.PaginationRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCedi();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.mu.routing.proto.DeliveryNewFilter.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.mu.routing.proto.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cedi = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.getCedi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.setCedi = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DeliveryNewFilter filters = 3;
 * @return {?proto.com.mu.routing.proto.DeliveryNewFilter}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.getFilters = function() {
  return /** @type{?proto.com.mu.routing.proto.DeliveryNewFilter} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.DeliveryNewFilter, 3));
};


/** @param {?proto.com.mu.routing.proto.DeliveryNewFilter|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.setFilters = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.clearFilters = function() {
  this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PaginationRequest pagination = 4;
 * @return {?proto.com.mu.routing.proto.PaginationRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationRequest, 4));
};


/** @param {?proto.com.mu.routing.proto.PaginationRequest|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.com.mu.routing.proto.MassiveDeliveryNewRequest.toObject, includeInstance),
    status: (f = msg.getStatus()) && proto.com.mu.routing.proto.StatusInfo.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse;
  return proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryNewRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryNewRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.StatusInfo;
      reader.readMessage(value,proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto.com.mu.routing.proto.PaginationResponse;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryNewRequest.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.mu.routing.proto.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MassiveDeliveryNewRequest requests = 1;
 * @return {!Array<!proto.com.mu.routing.proto.MassiveDeliveryNewRequest>}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.MassiveDeliveryNewRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryNewRequest, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.MassiveDeliveryNewRequest>} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.setRequestsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.MassiveDeliveryNewRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.clearRequestsList = function() {
  this.setRequestsList([]);
};


/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.mu.routing.proto.StatusInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.StatusInfo, 2));
};


/** @param {?proto.com.mu.routing.proto.StatusInfo|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.setStatus = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.clearStatus = function() {
  this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PaginationResponse pagination = 3;
 * @return {?proto.com.mu.routing.proto.PaginationResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationResponse, 3));
};


/** @param {?proto.com.mu.routing.proto.PaginationResponse|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryNewResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.com.mu.routing.proto.MassiveDeliveryRequest.toObject, includeInstance),
    status: (f = msg.getStatus()) && proto.com.mu.routing.proto.StatusInfo.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryResponse;
  return proto.com.mu.routing.proto.ListMassiveDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.StatusInfo;
      reader.readMessage(value,proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 3:
      var value = new proto.com.mu.routing.proto.PaginationResponse;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryRequest.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.mu.routing.proto.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MassiveDeliveryRequest requests = 1;
 * @return {!Array<!proto.com.mu.routing.proto.MassiveDeliveryRequest>}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.MassiveDeliveryRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryRequest, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.MassiveDeliveryRequest>} value */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.setRequestsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.MassiveDeliveryRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.clearRequestsList = function() {
  this.setRequestsList([]);
};


/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.mu.routing.proto.StatusInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.StatusInfo, 2));
};


/** @param {?proto.com.mu.routing.proto.StatusInfo|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.setStatus = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.clearStatus = function() {
  this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PaginationResponse pagination = 3;
 * @return {?proto.com.mu.routing.proto.PaginationResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationResponse, 3));
};


/** @param {?proto.com.mu.routing.proto.PaginationResponse|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    company: jspb.Message.getFieldWithDefault(msg, 2, ""),
    companyid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cedi: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cediid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    city: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cityid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    startdate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    starttime: jspb.Message.getFieldWithDefault(msg, 9, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 11, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cityname: jspb.Message.getFieldWithDefault(msg, 13, ""),
    vehicletypename: jspb.Message.getFieldWithDefault(msg, 14, ""),
    vehicletypeid: jspb.Message.getFieldWithDefault(msg, 15, 0),
    routed: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryRequest;
  return proto.com.mu.routing.proto.MassiveDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCedi(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCediid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttime(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityname(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicletypename(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicletypeid(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRouted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCedi();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCediid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getVehicletypename();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getVehicletypeid();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getRouted();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCompany = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 companyId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string cedi = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCedi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCedi = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 cediId = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCediid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCediid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string city = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCity = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 cityId = 7;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string startDate = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setStartdate = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string startTime = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getStarttime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setStarttime = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string endTime = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setEndtime = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string lat = 11;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string lng = 12;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string cityName = 13;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getCityname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setCityname = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string vehicleTypeName = 14;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getVehicletypename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setVehicletypename = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int32 vehicleTypeId = 15;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getVehicletypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setVehicletypeid = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional bool routed = 16;
 * @return {boolean}
 */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.getRouted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.MassiveDeliveryRequest.prototype.setRouted = function(value) {
  jspb.Message.setProto3BooleanField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    mddeliverypkgidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest;
  return proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setMddeliverypkgidList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMddeliverypkgidList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 mdDeliveryPkgId = 1;
 * @return {!Array<number>}
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.getMddeliverypkgidList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.setMddeliverypkgidList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.addMddeliverypkgid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.prototype.clearMddeliverypkgidList = function() {
  this.setMddeliverypkgidList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientaddress: jspb.Message.getFieldWithDefault(msg, 4, ""),
    latitud: jspb.Message.getFieldWithDefault(msg, 5, ""),
    longitud: jspb.Message.getFieldWithDefault(msg, 6, ""),
    weight: jspb.Message.getFieldWithDefault(msg, 7, ""),
    clientphone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    packagesize: jspb.Message.getFieldWithDefault(msg, 9, ""),
    received: jspb.Message.getFieldWithDefault(msg, 10, ""),
    createat: jspb.Message.getFieldWithDefault(msg, 11, ""),
    deliveredat: jspb.Message.getFieldWithDefault(msg, 12, ""),
    locality: jspb.Message.getFieldWithDefault(msg, 13, ""),
    mddeliverypkgid: jspb.Message.getFieldWithDefault(msg, 14, 0),
    iswrongaddress: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    clientpaymentmethod: jspb.Message.getFieldWithDefault(msg, 16, 0),
    productsvalue: jspb.Message.getFieldWithDefault(msg, 17, 0),
    description: jspb.Message.getFieldWithDefault(msg, 18, ""),
    numberitems: jspb.Message.getFieldWithDefault(msg, 19, 0),
    addressstatus: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryNewRequest;
  return proto.com.mu.routing.proto.MassiveDeliveryNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientaddress(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLatitud(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongitud(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientphone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackagesize(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceived(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreateat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliveredat(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocality(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMddeliverypkgid(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIswrongaddress(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClientpaymentmethod(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductsvalue(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberitems(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientaddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLatitud();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLongitud();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClientphone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPackagesize();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getReceived();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreateat();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDeliveredat();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLocality();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getMddeliverypkgid();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIswrongaddress();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getClientpaymentmethod();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getProductsvalue();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getNumberitems();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getAddressstatus();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional string clientId = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setClientid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string orderId = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string clientName = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setClientname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string clientAddress = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getClientaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setClientaddress = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string latitud = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getLatitud = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setLatitud = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string longitud = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getLongitud = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setLongitud = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string weight = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setWeight = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string clientPhone = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getClientphone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setClientphone = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string packageSize = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getPackagesize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setPackagesize = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string received = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getReceived = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setReceived = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string createAt = 11;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getCreateat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setCreateat = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string deliveredAt = 12;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getDeliveredat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setDeliveredat = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string locality = 13;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getLocality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setLocality = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 mdDeliveryPkgId = 14;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getMddeliverypkgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setMddeliverypkgid = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional bool isWrongAddress = 15;
 * @return {boolean}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getIswrongaddress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setIswrongaddress = function(value) {
  jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional int32 clientPaymentMethod = 16;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getClientpaymentmethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setClientpaymentmethod = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 productsValue = 17;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getProductsvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setProductsvalue = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string description = 18;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 numberItems = 19;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getNumberitems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setNumberitems = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string addressStatus = 20;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.getAddressstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryNewRequest.prototype.setAddressstatus = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetMassiveDeliveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetMassiveDeliveryRequest;
  return proto.com.mu.routing.proto.GetMassiveDeliveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetMassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetMassiveDeliveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.GetMassiveDeliveryRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetMassiveDeliveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    request: (f = msg.getRequest()) && proto.com.mu.routing.proto.MassiveDeliveryRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetMassiveDeliveryResponse;
  return proto.com.mu.routing.proto.GetMassiveDeliveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetMassiveDeliveryResponse}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryRequest.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetMassiveDeliveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetMassiveDeliveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional MassiveDeliveryRequest request = 1;
 * @return {?proto.com.mu.routing.proto.MassiveDeliveryRequest}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.getRequest = function() {
  return /** @type{?proto.com.mu.routing.proto.MassiveDeliveryRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryRequest, 1));
};


/** @param {?proto.com.mu.routing.proto.MassiveDeliveryRequest|undefined} value */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.setRequest = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.clearRequest = function() {
  this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.GetMassiveDeliveryResponse.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.PaginationRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.PaginationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PaginationRequest pagination = 2;
 * @return {?proto.com.mu.routing.proto.PaginationRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationRequest, 2));
};


/** @param {?proto.com.mu.routing.proto.PaginationRequest|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    servicesList: jspb.Message.toObjectList(msg.getServicesList(),
    proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject, includeInstance),
    addresswrong: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: (f = msg.getStatus()) && proto.com.mu.routing.proto.StatusInfo.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.com.mu.routing.proto.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse;
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader);
      msg.addServices(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddresswrong(value);
      break;
    case 3:
      var value = new proto.com.mu.routing.proto.StatusInfo;
      reader.readMessage(value,proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.com.mu.routing.proto.PaginationResponse;
      reader.readMessage(value,proto.com.mu.routing.proto.PaginationResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter
    );
  }
  f = message.getAddresswrong();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.mu.routing.proto.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MassiveDeliveryServiceDetail services = 1;
 * @return {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.getServicesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail>} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.setServicesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.addServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.MassiveDeliveryServiceDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.clearServicesList = function() {
  this.setServicesList([]);
};


/**
 * optional int32 addressWrong = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.getAddresswrong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.setAddresswrong = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional StatusInfo status = 3;
 * @return {?proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.mu.routing.proto.StatusInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.StatusInfo, 3));
};


/** @param {?proto.com.mu.routing.proto.StatusInfo|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.setStatus = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.clearStatus = function() {
  this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PaginationResponse pagination = 4;
 * @return {?proto.com.mu.routing.proto.PaginationResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.getPagination = function() {
  return /** @type{?proto.com.mu.routing.proto.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.PaginationResponse, 4));
};


/** @param {?proto.com.mu.routing.proto.PaginationResponse|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.setPagination = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.clearPagination = function() {
  this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest;
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    servicesList: jspb.Message.toObjectList(msg.getServicesList(),
    proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.toObject, includeInstance),
    status: (f = msg.getStatus()) && proto.com.mu.routing.proto.StatusInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse;
  return proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.deserializeBinaryFromReader);
      msg.addServices(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.StatusInfo;
      reader.readMessage(value,proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MassiveDeliveryServiceCoordsDetail services = 1;
 * @return {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail>}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.getServicesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail>} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.setServicesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.addServices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.clearServicesList = function() {
  this.setServicesList([]);
};


/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.mu.routing.proto.StatusInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.StatusInfo, 2));
};


/** @param {?proto.com.mu.routing.proto.StatusInfo|undefined} value */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.setStatus = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.clearStatus = function() {
  this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.ListMassiveDeliveryServiceCoordsResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.RouteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.RouteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.RouteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    country: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.RouteRequest}
 */
proto.com.mu.routing.proto.RouteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.RouteRequest;
  return proto.com.mu.routing.proto.RouteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.RouteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.RouteRequest}
 */
proto.com.mu.routing.proto.RouteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.RouteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.RouteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.RouteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 requestId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteRequest.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteRequest.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string country = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.RouteNewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.RouteNewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteNewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cityid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cedipointid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    startdate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    starttime: jspb.Message.getFieldWithDefault(msg, 5, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    cityname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    vehicletypename: jspb.Message.getFieldWithDefault(msg, 8, ""),
    vehicletypeid: jspb.Message.getFieldWithDefault(msg, 9, 0),
    country: jspb.Message.getFieldWithDefault(msg, 10, ""),
    packageslist: (f = msg.getPackageslist()) && proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.RouteNewRequest}
 */
proto.com.mu.routing.proto.RouteNewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.RouteNewRequest;
  return proto.com.mu.routing.proto.RouteNewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.RouteNewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.RouteNewRequest}
 */
proto.com.mu.routing.proto.RouteNewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCityid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCedipointid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStarttime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicletypename(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicletypeid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 11:
      var value = new proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest;
      reader.readMessage(value,proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.deserializeBinaryFromReader);
      msg.setPackageslist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.RouteNewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.RouteNewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteNewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCityid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCedipointid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStarttime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCityname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVehicletypename();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getVehicletypeid();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPackageslist();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 companyId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getCompanyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setCompanyid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cityId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getCityid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setCityid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 cediPointId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getCedipointid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setCedipointid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string startDate = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setStartdate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string startTime = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getStarttime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setStarttime = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string endTime = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setEndtime = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string cityName = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getCityname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setCityname = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string vehicleTypeName = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getVehicletypename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setVehicletypename = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 vehicleTypeId = 9;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getVehicletypeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setVehicletypeid = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string country = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setCountry = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional MassiveDeliveryPackageNewRequest packagesList = 11;
 * @return {?proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.getPackageslist = function() {
  return /** @type{?proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest, 11));
};


/** @param {?proto.com.mu.routing.proto.MassiveDeliveryPackageNewRequest|undefined} value */
proto.com.mu.routing.proto.RouteNewRequest.prototype.setPackageslist = function(value) {
  jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.clearPackageslist = function() {
  this.setPackageslist(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.RouteNewRequest.prototype.hasPackageslist = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.RouteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.RouteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    result: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    recordsquantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
    recordsprocessed: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.RouteResponse}
 */
proto.com.mu.routing.proto.RouteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.RouteResponse;
  return proto.com.mu.routing.proto.RouteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.RouteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.RouteResponse}
 */
proto.com.mu.routing.proto.RouteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRequestid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsquantity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRecordsprocessed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.RouteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.RouteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.RouteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRecordsquantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRecordsprocessed();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string result = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.RouteResponse.prototype.setResult = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 requestId = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteResponse.prototype.setRequestid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 recordsQuantity = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.getRecordsquantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteResponse.prototype.setRecordsquantity = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 recordsProcessed = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.RouteResponse.prototype.getRecordsprocessed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.RouteResponse.prototype.setRecordsprocessed = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail;
  return proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string serviceId = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.getServiceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.setServiceid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string clientName = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.setClientname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string orderId = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string lat = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string lng = 11;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceCoordsDetail.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    serviceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    address: jspb.Message.getFieldWithDefault(msg, 5, ""),
    orderid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    weight: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, ""),
    lat: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lng: jspb.Message.getFieldWithDefault(msg, 11, ""),
    deliveryorder: jspb.Message.getFieldWithDefault(msg, 12, 0),
    route: jspb.Message.getFieldWithDefault(msg, 13, 0),
    storeid: jspb.Message.getFieldWithDefault(msg, 14, ""),
    idclientpoint: jspb.Message.getFieldWithDefault(msg, 15, ""),
    clientpointname: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.MassiveDeliveryServiceDetail;
  return proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeight(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLat(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLng(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDeliveryorder(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoute(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdclientpoint(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientpointname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.MassiveDeliveryServiceDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServiceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getWeight();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLat();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLng();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDeliveryorder();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getRoute();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getStoreid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIdclientpoint();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getClientpointname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setRequestid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string serviceId = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getServiceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setServiceid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string clientId = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setClientid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string clientName = 4;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setClientname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string address = 5;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string orderId = 6;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string weight = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setWeight = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string phone = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setPhone = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string status = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string lat = 10;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getLat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setLat = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string lng = 11;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getLng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setLng = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int32 deliveryOrder = 12;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getDeliveryorder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setDeliveryorder = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 route = 13;
 * @return {number}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getRoute = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setRoute = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string storeId = 14;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getStoreid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setStoreid = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string idClientPoint = 15;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getIdclientpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setIdclientpoint = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string clientPointName = 16;
 * @return {string}
 */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.getClientpointname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.MassiveDeliveryServiceDetail.prototype.setClientpointname = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateVehicleOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    vehicleid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    routingid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    serviceidList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateVehicleOrderRequest}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateVehicleOrderRequest;
  return proto.com.mu.routing.proto.UpdateVehicleOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateVehicleOrderRequest}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoutingid(value);
      break;
    case 3:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setServiceidList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateVehicleOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRoutingid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getServiceidList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 vehicleId = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.getVehicleid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.setVehicleid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 routingId = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.getRoutingid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.setRoutingid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated int32 serviceId = 3;
 * @return {!Array<number>}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.getServiceidList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<number>} value */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.setServiceidList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.addServiceid = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.UpdateVehicleOrderRequest.prototype.clearServiceidList = function() {
  this.setServiceidList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.UpdateVehicleOrderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.UpdateVehicleOrderResponse}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.UpdateVehicleOrderResponse;
  return proto.com.mu.routing.proto.UpdateVehicleOrderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.UpdateVehicleOrderResponse}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.UpdateVehicleOrderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.UpdateVehicleOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.UpdateVehicleOrderResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetFileSignedUrlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetFileSignedUrlRequest}
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetFileSignedUrlRequest;
  return proto.com.mu.routing.proto.GetFileSignedUrlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetFileSignedUrlRequest}
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetFileSignedUrlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string fileId = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.prototype.getFileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.GetFileSignedUrlRequest.prototype.setFileid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.GetFileSignedUrlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    signedurl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: (f = msg.getStatus()) && proto.com.mu.routing.proto.StatusInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.GetFileSignedUrlResponse}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.GetFileSignedUrlResponse;
  return proto.com.mu.routing.proto.GetFileSignedUrlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.GetFileSignedUrlResponse}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedurl(value);
      break;
    case 2:
      var value = new proto.com.mu.routing.proto.StatusInfo;
      reader.readMessage(value,proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.GetFileSignedUrlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.GetFileSignedUrlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignedurl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string signedUrl = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.getSignedurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.setSignedurl = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional StatusInfo status = 2;
 * @return {?proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.getStatus = function() {
  return /** @type{?proto.com.mu.routing.proto.StatusInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.mu.routing.proto.StatusInfo, 2));
};


/** @param {?proto.com.mu.routing.proto.StatusInfo|undefined} value */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.setStatus = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.clearStatus = function() {
  this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.mu.routing.proto.GetFileSignedUrlResponse.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.StatusInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.StatusInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.StatusInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.StatusInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errorcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.StatusInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.StatusInfo;
  return proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.StatusInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.StatusInfo}
 */
proto.com.mu.routing.proto.StatusInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.mu.routing.proto.StatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {!proto.com.mu.routing.proto.ErrorCode} */ (reader.readEnum());
      msg.setErrorcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.StatusInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.StatusInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.StatusInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getErrorcode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional StatusType status = 1;
 * @return {!proto.com.mu.routing.proto.StatusType}
 */
proto.com.mu.routing.proto.StatusInfo.prototype.getStatus = function() {
  return /** @type {!proto.com.mu.routing.proto.StatusType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.com.mu.routing.proto.StatusType} value */
proto.com.mu.routing.proto.StatusInfo.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ErrorCode errorCode = 2;
 * @return {!proto.com.mu.routing.proto.ErrorCode}
 */
proto.com.mu.routing.proto.StatusInfo.prototype.getErrorcode = function() {
  return /** @type {!proto.com.mu.routing.proto.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.com.mu.routing.proto.ErrorCode} value */
proto.com.mu.routing.proto.StatusInfo.prototype.setErrorcode = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.StatusInfo.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.StatusInfo.prototype.setMessage = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.PaginationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.PaginationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.PaginationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PaginationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.PaginationRequest}
 */
proto.com.mu.routing.proto.PaginationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.PaginationRequest;
  return proto.com.mu.routing.proto.PaginationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.PaginationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.PaginationRequest}
 */
proto.com.mu.routing.proto.PaginationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.PaginationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.PaginationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.PaginationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PaginationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationRequest.prototype.setPage = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationRequest.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.PaginationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.PaginationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PaginationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalpages: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalrows: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.PaginationResponse}
 */
proto.com.mu.routing.proto.PaginationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.PaginationResponse;
  return proto.com.mu.routing.proto.PaginationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.PaginationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.PaginationResponse}
 */
proto.com.mu.routing.proto.PaginationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalpages(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalrows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.PaginationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.PaginationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PaginationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTotalpages();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalrows();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationResponse.prototype.setPage = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationResponse.prototype.setLimit = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 totalPages = 3;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.getTotalpages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationResponse.prototype.setTotalpages = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 totalRows = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.PaginationResponse.prototype.getTotalrows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PaginationResponse.prototype.setTotalrows = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListCountriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListCountriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListCountriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCountriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    namequery: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListCountriesRequest}
 */
proto.com.mu.routing.proto.ListCountriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListCountriesRequest;
  return proto.com.mu.routing.proto.ListCountriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListCountriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListCountriesRequest}
 */
proto.com.mu.routing.proto.ListCountriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamequery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListCountriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListCountriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListCountriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCountriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamequery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string nameQuery = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListCountriesRequest.prototype.getNamequery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListCountriesRequest.prototype.setNamequery = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListCountriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListCountriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListCountriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCountriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    countriesList: jspb.Message.toObjectList(msg.getCountriesList(),
    proto.com.mu.routing.proto.Country.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListCountriesResponse}
 */
proto.com.mu.routing.proto.ListCountriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListCountriesResponse;
  return proto.com.mu.routing.proto.ListCountriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListCountriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListCountriesResponse}
 */
proto.com.mu.routing.proto.ListCountriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.Country;
      reader.readMessage(value,proto.com.mu.routing.proto.Country.deserializeBinaryFromReader);
      msg.addCountries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListCountriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListCountriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListCountriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.Country.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Country countries = 1;
 * @return {!Array<!proto.com.mu.routing.proto.Country>}
 */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.getCountriesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.Country>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.Country, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.Country>} value */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.setCountriesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.Country=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.Country}
 */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.addCountries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.Country, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListCountriesResponse.prototype.clearCountriesList = function() {
  this.setCountriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.Country.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.Country.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.Country} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Country.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iso2: jspb.Message.getFieldWithDefault(msg, 3, ""),
    active: jspb.Message.getFieldWithDefault(msg, 4, 0),
    iva: jspb.Message.getFieldWithDefault(msg, 5, 0),
    payiva: jspb.Message.getFieldWithDefault(msg, 6, 0),
    calculateby: jspb.Message.getFieldWithDefault(msg, 7, ""),
    indicative: jspb.Message.getFieldWithDefault(msg, 8, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.Country}
 */
proto.com.mu.routing.proto.Country.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.Country;
  return proto.com.mu.routing.proto.Country.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.Country} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.Country}
 */
proto.com.mu.routing.proto.Country.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIso2(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActive(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIva(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPayiva(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalculateby(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndicative(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.Country.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.Country.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.Country} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.Country.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIso2();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActive();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIva();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPayiva();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCalculateby();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIndicative();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.Country.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Country.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.Country.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Country.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string iso2 = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.Country.prototype.getIso2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Country.prototype.setIso2 = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 active = 4;
 * @return {number}
 */
proto.com.mu.routing.proto.Country.prototype.getActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Country.prototype.setActive = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 iva = 5;
 * @return {number}
 */
proto.com.mu.routing.proto.Country.prototype.getIva = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Country.prototype.setIva = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 payIva = 6;
 * @return {number}
 */
proto.com.mu.routing.proto.Country.prototype.getPayiva = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.Country.prototype.setPayiva = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string calculateBy = 7;
 * @return {string}
 */
proto.com.mu.routing.proto.Country.prototype.getCalculateby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Country.prototype.setCalculateby = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string indicative = 8;
 * @return {string}
 */
proto.com.mu.routing.proto.Country.prototype.getIndicative = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Country.prototype.setIndicative = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string currency = 9;
 * @return {string}
 */
proto.com.mu.routing.proto.Country.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.Country.prototype.setCurrency = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    namequery: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest;
  return proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamequery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamequery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string nameQuery = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.prototype.getNamequery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListDeliveryPackageSizeRequest.prototype.setNamequery = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.PackageSizes.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.PackageSizes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.PackageSizes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PackageSizes.toObject = function(includeInstance, msg) {
  var f, obj = {
    namesize: jspb.Message.getFieldWithDefault(msg, 1, ""),
    codesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.PackageSizes}
 */
proto.com.mu.routing.proto.PackageSizes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.PackageSizes;
  return proto.com.mu.routing.proto.PackageSizes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.PackageSizes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.PackageSizes}
 */
proto.com.mu.routing.proto.PackageSizes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamesize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCodesize(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.PackageSizes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.PackageSizes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.PackageSizes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.PackageSizes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamesize();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCodesize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string nameSize = 1;
 * @return {string}
 */
proto.com.mu.routing.proto.PackageSizes.prototype.getNamesize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.PackageSizes.prototype.setNamesize = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 codeSize = 2;
 * @return {number}
 */
proto.com.mu.routing.proto.PackageSizes.prototype.getCodesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.PackageSizes.prototype.setCodesize = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.com.mu.routing.proto.PackageSizes.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.PackageSizes.prototype.setActive = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    packagesizeList: jspb.Message.toObjectList(msg.getPackagesizeList(),
    proto.com.mu.routing.proto.PackageSizes.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    result: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse;
  return proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.PackageSizes;
      reader.readMessage(value,proto.com.mu.routing.proto.PackageSizes.deserializeBinaryFromReader);
      msg.addPackagesize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackagesizeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.PackageSizes.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated PackageSizes packageSize = 1;
 * @return {!Array<!proto.com.mu.routing.proto.PackageSizes>}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.getPackagesizeList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.PackageSizes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.PackageSizes, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.PackageSizes>} value */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.setPackagesizeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.PackageSizes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.PackageSizes}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.addPackagesize = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.PackageSizes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.clearPackagesizeList = function() {
  this.setPackagesizeList([]);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string result = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListDeliveryPackageSizeResponse.prototype.setResult = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListLocalitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListLocalitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idcity: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListLocalitiesRequest}
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListLocalitiesRequest;
  return proto.com.mu.routing.proto.ListLocalitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListLocalitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListLocalitiesRequest}
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIdcity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListLocalitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListLocalitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdcity();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 idCity = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.ListLocalitiesRequest.prototype.getIdcity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.ListLocalitiesRequest.prototype.setIdcity = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.LocalitiesList.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.LocalitiesList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.LocalitiesList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.LocalitiesList.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.LocalitiesList}
 */
proto.com.mu.routing.proto.LocalitiesList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.LocalitiesList;
  return proto.com.mu.routing.proto.LocalitiesList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.LocalitiesList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.LocalitiesList}
 */
proto.com.mu.routing.proto.LocalitiesList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.LocalitiesList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.LocalitiesList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.LocalitiesList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.LocalitiesList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.mu.routing.proto.LocalitiesList.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.com.mu.routing.proto.LocalitiesList.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.LocalitiesList.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.LocalitiesList.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.com.mu.routing.proto.LocalitiesList.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.com.mu.routing.proto.LocalitiesList.prototype.setActive = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.mu.routing.proto.ListLocalitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.mu.routing.proto.ListLocalitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    localitiesList: jspb.Message.toObjectList(msg.getLocalitiesList(),
    proto.com.mu.routing.proto.LocalitiesList.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    result: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.mu.routing.proto.ListLocalitiesResponse}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.mu.routing.proto.ListLocalitiesResponse;
  return proto.com.mu.routing.proto.ListLocalitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.mu.routing.proto.ListLocalitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.mu.routing.proto.ListLocalitiesResponse}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.mu.routing.proto.LocalitiesList;
      reader.readMessage(value,proto.com.mu.routing.proto.LocalitiesList.deserializeBinaryFromReader);
      msg.addLocalities(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.mu.routing.proto.ListLocalitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.mu.routing.proto.ListLocalitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocalitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.mu.routing.proto.LocalitiesList.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated LocalitiesList localities = 1;
 * @return {!Array<!proto.com.mu.routing.proto.LocalitiesList>}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.getLocalitiesList = function() {
  return /** @type{!Array<!proto.com.mu.routing.proto.LocalitiesList>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.mu.routing.proto.LocalitiesList, 1));
};


/** @param {!Array<!proto.com.mu.routing.proto.LocalitiesList>} value */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.setLocalitiesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.mu.routing.proto.LocalitiesList=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.mu.routing.proto.LocalitiesList}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.addLocalities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.mu.routing.proto.LocalitiesList, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.clearLocalitiesList = function() {
  this.setLocalitiesList([]);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.setStatus = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string result = 3;
 * @return {string}
 */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.com.mu.routing.proto.ListLocalitiesResponse.prototype.setResult = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.com.mu.routing.proto.DeliveryStatusType = {
  UNKNOWN_DELIVERY_STATUS_TYPE: 0,
  ROUTED: 1,
  PENDING_ROUTING: 2,
  CREATED: 3
};

/**
 * @enum {number}
 */
proto.com.mu.routing.proto.DeliveryPackageSize = {
  UNKNOWN_PACKAGE_SIZE: 0,
  BOX: 1,
  BAG: 2
};

/**
 * @enum {number}
 */
proto.com.mu.routing.proto.DeliveryPackageStaus = {
  RECEIVED: 0,
  NOT_RECEIVED: 1
};

/**
 * @enum {number}
 */
proto.com.mu.routing.proto.StatusType = {
  UNKNOWN_STATUS_TYPE: 0,
  SUCCESS: 1,
  ERROR: 2
};

/**
 * @enum {number}
 */
proto.com.mu.routing.proto.ErrorCode = {
  UNKNOWN_ERROR_CODE_TYPE: 0,
  OK: 1,
  GENERAL_ERROR: 2
};

goog.object.extend(exports, proto.com.mu.routing.proto);
